import { c as _c } from "react/compiler-runtime";
import { css, cva } from '@repo/pandacss/css';
import { visuallyHidden } from '@repo/pandacss/patterns';
import { EllipsisIcon } from '@repo/ui/icons/EllipsisIcon';
import { Typography } from '@repo/ui/Typography';
import Image from 'next/image';
import type { KeyboardEvent, Ref } from 'react';
import type { AsyncOptionGroup } from '@/features/funnel/async-options/types';
import type { getChoiceSetPositionProps } from '../choiceGroupA11y';
import { baseRowClass, selectedRowClass } from './styles';
const iconWrapperRecipe = cva({
  base: {
    flexShrink: '[0]',
    width: '[40px]',
    height: '[40px]',
    bg: 'common.white',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  variants: {
    variant: {
      circle: {
        rounded: 'full',
        border: '[0.5px solid {colors.neutral.lighter}]',
        p: '1'
      },
      square: {
        rounded: 'none',
        border: 'none',
        p: '0'
      }
    }
  }
});
type SetPositionProps = ReturnType<typeof getChoiceSetPositionProps>;
type OptionRowProps = {
  option: AsyncOptionGroup['options'][number];
  checked: boolean;
  disabled: boolean;
  onToggle: (value: string) => void;
  name: string;
  iconVariant: 'circle' | 'square';
  setPositionProps: SetPositionProps;
  tabIndex: number;
  inputRef?: Ref<HTMLInputElement>;
  onInputFocus?: () => void;
  onInputKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
};
export function OptionRow(t0) {
  const $ = _c(33);
  const {
    option,
    checked,
    disabled,
    onToggle,
    name,
    iconVariant,
    setPositionProps,
    tabIndex,
    inputRef,
    onInputFocus,
    onInputKeyDown
  } = t0;
  let t1;
  if ($[0] !== iconVariant) {
    t1 = iconWrapperRecipe({
      variant: iconVariant
    });
    $[0] = iconVariant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const wrapper = t1;
  const className = checked ? `${baseRowClass} ${selectedRowClass}` : baseRowClass;
  const isOther = option.value === "other";
  const t2 = option.value;
  let t3;
  if ($[2] !== onToggle || $[3] !== option.value) {
    t3 = () => onToggle(option.value);
    $[2] = onToggle;
    $[3] = option.value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = visuallyHidden();
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== checked || $[7] !== disabled || $[8] !== inputRef || $[9] !== name || $[10] !== onInputFocus || $[11] !== onInputKeyDown || $[12] !== option.value || $[13] !== setPositionProps || $[14] !== t3 || $[15] !== tabIndex) {
    t5 = <input ref={inputRef} type="checkbox" name={name} value={t2} checked={checked} disabled={disabled} tabIndex={tabIndex} onChange={t3} onFocus={onInputFocus} onKeyDown={onInputKeyDown} {...setPositionProps} className={t4} />;
    $[6] = checked;
    $[7] = disabled;
    $[8] = inputRef;
    $[9] = name;
    $[10] = onInputFocus;
    $[11] = onInputKeyDown;
    $[12] = option.value;
    $[13] = setPositionProps;
    $[14] = t3;
    $[15] = tabIndex;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== isOther || $[18] !== option.imageInvert || $[19] !== option.imageURL || $[20] !== option.label) {
    t6 = isOther ? <EllipsisIcon /> : option.imageURL ? <Image src={option.imageURL} alt="" width={40} height={40} className={css({
      width: "[100%]",
      height: "[100%]",
      objectFit: "contain",
      filter: option.imageInvert ? "[invert(1)]" : "[none]"
    })} /> : <Typography as="span" variant="body.small" css={{
      width: "[100%]",
      height: "[100%]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bg: "greens.lightest",
      color: "greens.dark",
      fontWeight: "bold"
    }} aria-hidden="true">{option.label.charAt(0)}</Typography>;
    $[17] = isOther;
    $[18] = option.imageInvert;
    $[19] = option.imageURL;
    $[20] = option.label;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t6 || $[23] !== wrapper) {
    t7 = <span className={wrapper}>{t6}</span>;
    $[22] = t6;
    $[23] = wrapper;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      flex: "[1]",
      fontSize: "[14px]",
      lineHeight: "[1.2]"
    };
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== option.label) {
    t9 = <Typography as="span" variant="body" css={t8}>{option.label}</Typography>;
    $[26] = option.label;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== className || $[29] !== t5 || $[30] !== t7 || $[31] !== t9) {
    t10 = <label className={className}>{t5}{t7}{t9}</label>;
    $[28] = className;
    $[29] = t5;
    $[30] = t7;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
}